import { getUrlParam } from "_lib/utils"

window.LINK_TAG = 11

export const CLIENT_TYPE = 
            getUrlParam('concept') == 1
              ? 'heybox_concept'
              : window.location.host.startsWith('v5') || getUrlParam('client_type') == 'maxjia'
                ? 'maxjia'
                : 'heybox'

export const LINK_PROTOCOL = 
  'heybox://' + JSON.stringify({
    protocol_type: 'openLink',
    link: {
      link_tag: window.LINK_TAG,
      linkid: getUrlParam('link_id'),
      use_concept_type: getUrlParam('concept')
    }
  })